module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/infografica_1.2.51cba8be.pdf";